import { jsx as m, Fragment as f } from "react/jsx-runtime";
import { useCallback as g } from "react";
import { Input as a } from "./Input.component.js";
const l = ({
  value: e,
  onInput: r,
  type: s,
  ...i
}) => {
  const c = g(
    (t) => {
      s === "integer" ? r == null || r(parseInt(t)) : r == null || r(parseFloat(t));
    },
    [r, s]
  );
  return /* @__PURE__ */ m(f, { children: /* @__PURE__ */ m(
    a,
    {
      step: s === "integer" ? 1 : 0.1,
      value: e == null ? void 0 : e.toString(),
      onInput: c,
      ...i,
      type: "number"
    }
  ) });
};
export {
  l as NumberInput
};
